import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import { tracker } from 'app-components/utils/core';
import store from 'app-components/utils/redux-store';
import { trackingEvents } from 'containers/SimplifiAiAssistant/AiAssistant/aiEvents';
import { Map as ImmutableMap } from 'immutable';

import type { AILegalDisclaimerProps } from './index';

export const AI_LEGAL_DISCLAIMER = 'AI_LEGAL_DISCLAIMER';

export const closeAILegalDisclaimer = () => {
  tracker.track(trackingEvents.AIConsentDismissed);
  store?.dispatch(rootUiActions.removeDialog(AI_LEGAL_DISCLAIMER));
};

const useAILegalDisclaimer = () => {
  return (props?: Omit<AILegalDisclaimerProps, 'onClose'>) => {
    store?.dispatch(
      rootUiActions.createDialog(
        rootUiTypes.mkRootUiData({
          id: AI_LEGAL_DISCLAIMER,
          type: AI_LEGAL_DISCLAIMER,
          props: ImmutableMap({ ...props, onClose: closeAILegalDisclaimer }),
        }),
      ),
    );
  };
};

export default useAILegalDisclaimer;
